<template>
  <div class="RatingPage">
    <div class="rating-header">
      <img :src="cx_header_logo" alt="logo"/>
    </div>
    <div class="rating-body">
      <b-row class="justify-content-center">
        <b-col cols="12" class="rating-title">
          <span>Recebemos sua avaliação, muito obrigado!</span>
        </b-col>
        <b-col cols="12" class="rating-received">
          <div class="rating-box">
            <b-form-rating v-model="rating" size="lg" color="#FDCB2E" readonly></b-form-rating>
          </div>
        </b-col>
        <b-col v-if="registered" cols="12" class="d-flex justify-content-center">
          <div class="rating-message">
            Registramos apenas 1 avaliação por atendimento, caso queira realizar uma nova avaliação, realize um novo atendimento.
          </div>
        </b-col>
        <b-col cols="12"  class="d-flex justify-content-center">
          <div class="new-services-message">
            <label>Gostaria de conhecer outros serviços para continuar cuidando da sua saúde?</label>
            <label>Encontre serviços de qualidade perto de você, compare preços e agende seu atendimento.</label>
          </div>
        </b-col>
        <b-col cols="12">
          <a href="https://saude.clinicarx.com.br" target="_blank">
            <button class="service-button">Conhecer outros serviços {{ servicesUrl }}</button>
          </a>
        </b-col>
        <b-col cols="12">
          <img class="img-footer" src="@/assets/images/medical-prescription.png" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import RatingPage from "@/views/Rating/RatingPage";
export default RatingPage;
</script>

<style lang="scss">
@import "RatingPage.scss";
</style>
